import { EMPTY_PHONE } from "@/utils/customerProfile.js";
import "./phone-fields.css";

const MAX_PHONES = 5;

export default function PhoneFields({ phones, onChange, idPrefix = "phone", requirePhoneNumber = true }) {
    const updatePhone = (index, field, value) => {
        const next = phones.map((phone, phoneIndex) => (
            phoneIndex === index ? { ...phone, [field]: value } : phone
        ));
        onChange(next);
    };

    const addPhone = () => {
        if (phones.length >= MAX_PHONES) {
            return;
        }
        onChange([...phones, { ...EMPTY_PHONE }]);
    };

    const removePhone = (index) => {
        if (phones.length <= 1) {
            return;
        }
        onChange(phones.filter((_, phoneIndex) => phoneIndex !== index));
    };

    return (
        <div className="phone-fields">
            <div className="phone-fields-header">
                <span>Numéros de téléphone</span>
                {phones.length < MAX_PHONES && (
                    <button type="button" className="link-btn" onClick={addPhone}>
                        Ajouter un numéro
                    </button>
                )}
            </div>
            {phones.map((phone, index) => (
                <div key={`${idPrefix}-${index}`} className="phone-fields-row">
                    <label className="field">
                        Numéro {index + 1}
                        <input
                            value={phone.phoneNumber}
                            onChange={(event) => updatePhone(index, "phoneNumber", event.target.value)}
                            placeholder="+237 6XX XX XX XX"
                            required={requirePhoneNumber}
                        />
                    </label>
                    <label className="field">
                        Libellé (optionnel)
                        <input
                            value={phone.label}
                            onChange={(event) => updatePhone(index, "label", event.target.value)}
                            placeholder="Mobile, Bureau..."
                        />
                    </label>
                    {phones.length > 1 && (
                        <button
                            type="button"
                            className="link-btn phone-fields-remove"
                            onClick={() => removePhone(index)}
                        >
                            Supprimer
                        </button>
                    )}
                </div>
            ))}
        </div>
    );
}
